export default function Testimonials() {
  const testimonials = [
    {
      text: '"CareBridge has been a game-changer for our family. My mom lives alone, and now I can see if she has taken her medication and eaten properly without constantly calling her. The peace of mind is priceless."',
      initials: 'SM',
      bg: 'bg-accent-400',
      name: 'Sarah Mitchell',
      role: 'Daughter & Primary Caregiver',
      location: 'New York, NY',
    },
    {
      text: '"As a working dad, I used to worry about my dad all day. The SOS button gives him confidence, and the family dashboard lets me and my sister coordinate care without the endless text messages. Brilliant app."',
      initials: 'JO',
      bg: 'bg-primary-500',
      name: "James O'Connor",
      role: 'Son & Part-Time Caregiver',
      location: 'Chicago, IL',
    },
    {
      text: '"I was nervous about using an app, but CareBridge is so simple. The buttons are big and clear, and my family can see I am okay. I love that my grandchildren can check in too. It makes me feel safe and connected."',
      initials: 'MC',
      bg: 'bg-secondary-500',
      name: 'Margaret Chen',
      role: 'Elderly Parent & App User',
      location: 'Austin, TX',
    },
  ];

  return (
    <section className="bg-background-200/70 py-16 md:py-24 px-4 md:px-8 lg:px-12">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-accent-400/10 rounded-full px-3 py-1.5 mb-5">
            <i className="ri-heart-fill text-accent-400 text-xs"></i>
            <span className="text-xs font-semibold text-accent-500 uppercase tracking-wider">Real Stories</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 mb-4">
            Families are already caring better together
          </h2>
          <p className="text-base md:text-lg text-foreground-600/80 max-w-xl mx-auto">
            Hear from families who are using CareBridge to stay connected and keep their loved ones safe.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, idx) => (
            <div
              key={idx}
              className="bg-white rounded-2xl p-6 md:p-8 border border-background-200/70 hover:shadow-lg transition-all duration-300 flex flex-col"
            >
              <div className="flex items-center gap-1 mb-5">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-accent-400 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700/80 leading-relaxed mb-6 flex-1">
                {t.text}
              </p>
              <div className="flex items-center gap-3 pt-5 border-t border-background-200/70">
                <div className={`w-10 h-10 flex items-center justify-center rounded-full ${t.bg} text-white text-sm font-semibold`}>
                  {t.initials}
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                  <p className="text-xs text-foreground-600/50">{t.role} · {t.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}